export default __webpack_public_path__ + "static/media/brucoffeelogo.7d05fe76.png";